import { render } from "./PublicList.vue?vue&type=template&id=1f3fe48a"
import script from "./PublicList.vue?vue&type=script&lang=js"
export * from "./PublicList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__